import styled from 'styled-components'

export const Wrapper = styled.div`
    position: relative;
`

export const FormDiv = styled.div`
    z-index: 1;
`